import React, { Component } from 'react';
import { connect } from 'react-redux';
import { submit, isSubmitting, change } from 'redux-form';

import FlatButton from 'material-ui/FlatButton';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import withMobileDialog from '@material-ui/core/withMobileDialog';

import { localize } from 'react-localize-redux';

import { colors } from 'helpers/ColorHelper';
import { AccentColor } from 'helpers/AccentColorHelper';
import { serviceRequestOptions } from 'helpers/VerbiageHelper';

import RequestMaintenanceKioskForm from './RequestMaintenanceKioskForm';

const changeFieldValue = (field, value) => change('new_kiosk_ticket_form', field, value);

const RequestMaintenanceDialog = withMobileDialog()(
  connect(
    store => ({
      submitting: isSubmitting('new_kiosk_ticket_form')(store),
    }),
    {
      submit,
    }
  )(
    class RequestMaintenanceDialog extends Component {
      render() {
        const { translate } = this.props;

        const style = {
          header: { margin: '10px 0 5px', textAlign: 'center' },
          period: { fontFamily: 'Circular-Black', color: AccentColor() },
          dialog_content: {
            borderTop: `5px solid ${AccentColor()}`,
            marginTop: '5px',
            paddingTop: '20px',
          },
          cancel: { color: AccentColor(), textTransform: 'uppercase' },
          submit: {
            color: 'white',
            backgroundColor: this.props.submitting ? colors.LIGHT_GRAY : AccentColor(),
            textTransform: 'uppercase',
          },
        };

        const createMaintenanceRequestOptions = {
          serviceRequest: translate('createMaintenanceRequest'),
          requestForMaintenance: translate('createMaintenanceRequestRFM'),
        };

        return (
          <Dialog
            disableBackdropClick
            fullScreen={this.props.fullScreen}
            open={this.props.isOpen}
            onClose={this.props.toggleDialog}
            aria-labelledby="create-maintenance-ticket"
            classes={{
              paper: 'form-dialog',
            }}
          >
            <DialogTitle id="create-maintenance-ticket">
              <h3 style={style.header}>
                {serviceRequestOptions(createMaintenanceRequestOptions)}
                <b style={style.period}>.</b>
              </h3>
            </DialogTitle>
            <DialogContent>
              <div style={style.dialog_content}>
                <RequestMaintenanceKioskForm
                  onSubmit={this.props.submitForm}
                  handleClose={this.props.toggleDialog}
                  isOpen={this.props.isOpen}
                  changeFieldValue={changeFieldValue}
                  properties={this.props.properties}
                />
              </div>
            </DialogContent>
            <DialogActions style={{ display: 'block' }}>
              <FlatButton onClick={this.props.toggleDialog} id="cancel-button" style={style.cancel}>
                {translate('close')}
              </FlatButton>
              <FlatButton
                variant="raised"
                onClick={() => this.props.submit('new_kiosk_ticket_form')}
                disabled={this.props.submitting}
                id="submit-button"
                style={style.submit}
              >
                {translate('create')}
              </FlatButton>
            </DialogActions>
          </Dialog>
        );
      }
    }
  )
);

export default localize()(RequestMaintenanceDialog);
